/* -----------------Globals--------------- */
import { useSafeAreaInsets } from "react-native-safe-area-context";

/* -----------------UI--------------- */
import { useDevice } from "@hooks/useDevice";
import Box from "@memorang/ui/components/Box";
import ScrollContainer from "@memorang/ui/components/ScrollContainer";
import CardSkeleton from "@memorang/ui/components/Skeletons/CardSkeleton";
import ReportCardsContainer from "../ReportCardsContainer";
import { SuggestedActionsChipsSkeleton } from "./SuggestedActionsChipsSkeleton";
import { SummaryCardSkeleton } from "./SummaryCardSkeleton";

type Props = {
	isSummativeTest?: boolean;
};

const ReportSkeleton = ({ isSummativeTest }: Props) => {
	const { isMobile } = useDevice();
	const insets = useSafeAreaInsets();

	const skeletonCards = [
		<SummaryCardSkeleton key="summary-skeleton" />,
		<Box key="suggested-actions-skeleton-container" marginVertical={-8}>
			<SuggestedActionsChipsSkeleton
				key="suggested-actions-skeleton"
				height={28}
			/>
		</Box>,
		<CardSkeleton key="performance-skeleton" numRows={5} />,
		<CardSkeleton key="items-skeleton" numRows={3} />,
		<CardSkeleton key="mastery-skeleton" numRows={4} />,
	];

	return (
		<>
			<ScrollContainer
				contentContainerStyle={{
					paddingTop: isSummativeTest && isMobile ? 84 : 58,
					paddingBottom: 88 + insets.bottom,
					paddingHorizontal: 16,
					gap: 16,
				}}
			>
				<ReportCardsContainer cards={skeletonCards} />
			</ScrollContainer>
		</>
	);
};

export default ReportSkeleton;
